export enum CommandDomainType {
  Control = 0,
  Land = 1,
  Air = 2,
  Maritime = 3,
  Space = 4,
  Cyber = 5,
  Common = 6,
  LRC = 7,
  Disaster = 8,
}

export enum LandCommandType {
  Movement = 0,
}

export enum AirCommandType {
  Intercept = 0,
  Strafe = 1,
}

export enum MaritimeCommandType {
  Submerge = 0,
}

export enum SpaceCommandType {
  Movement = 0,
}

export enum CyberCommandType {
  Movement = 0,
}

export enum CommandTimeType {
  ASAP = 0,
}
